import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Admin
import Dashboard from './Admin/Dashboard';

// Login Register
import Login from './Login/Login';
import Register from './Register/RegisterAdmin';

// Staff Gathering
import ScanQrGathering from './GatheringStaff/ScanQrGathering';

// Data
import DataPendaftaranCendekia from './Data/DataPendaftaranCendekia';

const App = () => {
  return (
    <div>
    <Router>
          <Routes>
            {/* Admin */}
            <Route path="/admin/dashboard" element={<Dashboard />} />

            {/* Login Register */}
            <Route path="/" element={ <Login />} />
            <Route path="/admin/login" element={ <Login />} />
            <Route path="/admin/register" element={ <Register />} />

            {/* Staff Gathering */}
            <Route path="/gathering-upi/scan" element={<ScanQrGathering />} />

            {/* Cendekia */}
            <Route path="/regis-cendekia" element={<DataPendaftaranCendekia />} />
          </Routes>
    </Router>
    </div>
  );
};


export default App;